class dayRanges {
  formatDate(d) {
    var day = new Date(d);
    return day.toISOString().substring(0, 13);
  }
  displayDate(d) {
    const dayNum = d.substring(8, 10);
    const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    const ordinal = (n) => {
      const v = n % 100;
      if (v >= 11 && v <= 13) return "th";
      switch (n % 10) {
        case 1:
          return "st";
        case 2:
          return "nd";
        case 3:
          return "rd";
        default:
          return "th";
      }
    };
    const formatted = `${dayNum}${ordinal(dayNum)} of ${monthNames[d.substring(5, 7) - 1]} ${d.substring(0, 4)}`;
    return formatted;
  }
  displayWeekString(date) {

    let weekYear = date.substring(0, 4);
    let month = date.substring(5, 7)-1;
    let day = date.substring(8,10);
    let dateObj = new Date(weekYear, month, day);

    let weekNumber = dayRange.getWeekFromDate(dateObj);

    return `Week ${weekNumber}, ${weekYear}`;
  }
  startTime(d) {
    var day = new Date(d);
    return new Date(day.setHours(0, 0, 0));
  }
  endTime(d) {
    var day = new Date(d);
    return new Date(day.setHours(24, 0, 0));
  }
  startOfWeek(date) {
    var d = new Date(date);
    var day = d.getDay() || 7;
    return new Date(this.startTime(this.editDay(-1 * (day - 1), date), date));
  }
  endOfWeek(d) {
    var date = new Date(d);
    var day = d.getDay() || 7;
    return new Date(this.endTime(this.editDay(7 - day, date), date));
  }
  startOfMonth(date) {
    var d = new Date(date);
    return this.startTime(new Date(d.getFullYear(), d.getMonth(), 1));
  }
  endOfMonth(date) {
    var d = new Date(date);
    return new Date(this.endTime(new Date(d.getFullYear(), d.getMonth() + 1, 0)));
  }
  editHour(hours, res = new Date()) {
    res = new Date(res);
    return new Date(res.setHours(res.getHours() + hours));
  }
  editDay(days, res = new Date()) {
    res = new Date(res);
    return new Date(res.setDate(res.getDate() + days));
  }
  editWeek(weeks, res = new Date()) {
    res = new Date(res);
    return new Date(res.setDate(res.getDate() + 7 * weeks));
  }
  editMonth(months, res = new Date()) {
    res = new Date(res);
    return new Date(res.setMonth(res.getMonth() + months));
  }
  editYear(years, res = new Date()) {
    res = new Date(res);
    let newYear = res.getFullYear() + years;
    return new Date(res.setFullYear(newYear)).getFullYear();
  }
  getDayRange(day) {
    return [this.formatDate(this.startTime(day)), this.formatDate(this.endTime(day))];
  }
  getWeekRange(day) {
    const start = this.startOfWeek(day);
    const end = this.endOfWeek(day);
    return [this.formatDate(this.startTime(start)), this.formatDate(this.endTime(end))];
  }
  getMonthRange(day) {
    const start = this.startOfMonth(day);
    const end = this.endOfMonth(day);
    return [this.formatDate(this.startTime(start)), this.formatDate(this.endTime(end))];
  }
  getYearRange(year) {
    const start = new Date("January 1," + year);
    const end = new Date("December 31," + year);
    return [this.formatDate(this.startTime(start)), this.formatDate(this.endTime(end))];
  }
  getToday() {
    return [this.formatDate(this.startTime(new Date())), this.formatDate(this.endTime(new Date()))];
  }
  getYesterday() {
    const yesterday = new Date(this.editDay(-1));
    return [this.formatDate(this.startTime(yesterday)), this.formatDate(this.endTime(yesterday))];
  }
  getLastWeekDay() {
    const day = new Date(this.editWeek(-1));
    return [this.formatDate(this.startTime(day)), this.formatDate(this.endTime(day))];
  }
  getThisWeek() {
    return [this.formatDate(this.startOfWeek(new Date())), this.formatDate(this.endOfWeek(new Date()))];
  }
  getLastWeek() {
    return [this.formatDate(this.startOfWeek(this.editWeek(-1))), this.formatDate(this.endOfWeek(this.editWeek(-1)))];
  }
  getThisMonth() {
    return [this.formatDate(this.startOfMonth(new Date())), this.formatDate(this.endOfMonth(new Date()))];
  }
  getLastMonth() {
    return [this.formatDate(this.startOfMonth(this.editMonth(-1))), this.formatDate(this.endOfMonth(this.editMonth(-1)))];
  }
  getLastYearMonth() {
    return [this.formatDate(this.startOfMonth(this.editYear(-1))), this.formatDate(this.endOfMonth(this.editYear(-1)))];
  }
  getMonthDays() {
    return new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).getDate();
  }
  getNumberOfDaysInMonth(day) {
    return new Date(new Date().getFullYear(), new Date(day).getMonth() + 1, 0).getDate();
  }

  compareLastYear(start, end) {
    let thisYear = new Date(start).getFullYear();
    let lastYear = thisYear - 1;

    let startDate = new Date(start);
    let endDate = new Date(end);

    startDate.setFullYear(lastYear);
    endDate.setFullYear(lastYear);

    return [this.formatDate(startDate), this.formatDate(endDate)];
  }

  getWeekFromDate(date) {
    const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
    const offset = yearStart.getDay();
    const weekNo = Math.ceil(((d - yearStart) / 86400000 + offset) / 7);
    return weekNo;
  }

  getDateOfWeek(w, y) {
    const simple = new Date(y, 0, 1 + (w - 1) * 7);
    const dow = simple.getDay();
    const ISOweekStart = simple;

    if (dow <= 4) {
      ISOweekStart.setDate(simple.getDate() - simple.getDay() + 1);
    } else {
      ISOweekStart.setDate(simple.getDate() + 8 - simple.getDay());
    }

    return ISOweekStart;
  }

  weekLabels(dates){
    let labels = [];
    dates.map((date) =>{
      let weekNumber = this.getWeekFromDate(date);
      if(!labels.includes(weekNumber)){
        labels.push(weekNumber);
      }
    })
    return labels;
  }
}

const dayRange = new dayRanges();
export { dayRange };
